export class ExternalPaths {
  public static new_dealership_form = "https://airtable.com/appJQEaDSuJq2gLIV/pagDeYNFsulsO5oAF/form";
  public static refund_request_form = "https://airtable.com/app5EETysP44vCh6H/pag6oLbzE1Nix8qgH/form";
  public static cep_banxico = "https://www.banxico.org.mx/cep/";
  public static sat_web_page = "https://verificacfdi.facturaelectronica.sat.gob.mx/";
  public static repuve_web_page = "https://www2.repuve.gob.mx:8443/ciudadania/";
  public static new_warranty_extended =
    "https://docs.google.com/forms/d/e/1FAIpQLSdpZN1vvUcHku3LhqAjISiM1C8zRJWRUZW7xMsHNpRJ6no-lw/viewform";
  public static privacy_policy = "https://www.nexu.mx/aviso_de_privacidad";
  public static contract_visitor_url = "https://www.nexu.mx/contract-visit/";
  public static early_settlement_url = "https://www.nexu.mx/early_settlement/";
  public static maps_key = "https://maps.googleapis.com/maps/api/js?key=";
  public static facebook = "https://web.facebook.com/pg/nexumx/about/?ref=page_internal";
  public static google = "https://www.google.com.mx/search?q=nexu.mx";
  public static twitter = "https://twitter.com/NexuMX";
  public static instagram = "https://www.instagram.com/nexu.mx/";
  public static drive_root = "http://drive.google.com/drive/folders/";
  public static whatsapp_page = "https://api.whatsapp.com/send?phone=52";
  public static whatsapp_api = "https://api.whatsapp.com/";
  public static google_maps_search = "http://maps.google.co.in/maps?q=";
  public static pipefy = "https://app.pipefy.com/pipes/304069666";
  public static car_photo_front = "https://prestemos-assets.s3.amazonaws.com/png/frente.png";
  public static car_photo_side = "https://prestemos-assets.s3.amazonaws.com/png/lateral.png";
  public static car_photo_oblique = "https://prestemos-assets.s3.amazonaws.com/png/oblicua.png";
  public static car_photo_vin = "https://prestemos-assets.s3.amazonaws.com/png/vin.png";
  public static commissions_performance_dashboard_url =
    "https://nexu.metabaseapp.com/public/dashboard/8b901c01-42e5-4b62-9a03-15c3471abd95";
  public static contributions_performance_dashboard_url =
    "https://nexu.metabaseapp.com/public/dashboard/8b88dcd7-5ea6-4c59-bc3b-9641f1b0b4f0";
  public static income_proof_validations_docs =
    "https://www.notion.so/Validaciones-de-comprobantes-de-ingresos-35b29d9cfa49801e9ccae23d3bee608c?source=copy_link";
}
